import {Store} from '../classes/store';
import {Injectable} from '@angular/core';
import {ApiLegacyService} from '../../../services/api/api.service';
import {PveTemplate} from '../../export/pve-template.interface';

@Injectable({
  providedIn: 'root'
})
export class PveTemplateStore extends Store<PveTemplate> {

  /** Constructor. */
  constructor(
    private api: ApiLegacyService
  ) {
    super();
  }

  load() {
    this.api.getPveTemplates().subscribe(pveTemplates => {
      this.setState(pveTemplates);
    });

    return this.state$;
  }
}
